import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { AdaTokenResponse } from '@core/ada/models/ada-token-response.interface';

@Injectable({
  providedIn: 'root',
})
export class AdaService {
  private readonly httpClient = inject(HttpClient);

  getAdaToken(): Observable<AdaTokenResponse> {
    const url = 'api/v1/ada/token';

    return this.httpClient.get<AdaTokenResponse>(environment.portalApiUrl + url);
  }
}
